import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CalendarModule } from 'primeng/primeng';
import { ChartsModule } from 'ng2-charts';
import { DataTableModule } from 'angular2-datatable';
import { SidebarModule } from 'ng-sidebar';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { AuthorizationGuard } from './authorization-guard';

import { AppRoutes } from './application-routes';
import { AppComponent } from './app.component';

import { ContactComponent } from './home/contact.component';
import { HomeComponent } from './home/home.component';
import { DatosCorrespondenciaComponent } from './home/datoscorrespondencia.component';
import { ConsumofacturaComponent } from './home/consumofactura.component';
import { FaqComponent } from './home/faq.component';
import { GraficoComponent } from './home/Components/grafico.component';
import { FaqGuadalaguaComponent } from './home/Faqs/faqGuadalagua.component';
import { FaqSoriaComponent } from './home/Faqs/faqSoria.component';
import { FaqValorizaComponent } from './home/Faqs/faqValoriza.component';
import { UploadFileComponent } from './home/Components/uploadfile.component';
import { CalendarioComponent } from './home/Components/calendario.component';
import { ChangePasswordComponent } from './home/changePassword.component';
import { SimuladorConsumoComponent } from './home/simuladorConsumo.component';
import { UsuarioComponent } from './home/usuario.component';
import { DomiciliacionFacturaComponent } from './home/domiciliacionFactura.component';
import { LecturaContadorComponent } from './home/lecturacontador.component';

import { LoginComponent } from './public/login.component';
import { RegisterComponent } from './public/register.component';
import { ContactpublicComponent } from './public/contactpublic.component';
import { MainComponent } from './public/main.component';
import { ResetPasswordComponent } from './public/resetPassword.component';
import { ValCodA2PComponent } from './public/valCodA2P.component';
import { ValTlfA2PComponent } from './public/valTlfA2P.component';

import { SessionService } from './services/session.service';

import { HeaderComponent } from './shared/header.component';
import { HeaderLoginComponent } from './shared/headerLogin.component';
import { MenudesktopComponent } from './shared/menudesktop.component';
import { MenumobileComponent } from './shared/menumobile.component';
import { AlertBoxComponent } from './shared/alertbox.component';


import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { CookieLawModule } from './shared/cookie-law/cookie-law.module';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { DocumentosComponent } from './home/documentos.component';
import { EncuestasComponent } from './home/encuestas.component';
import { ReclamacionesComponent } from './home/reclamaciones.component';
import { TramitesComponent } from './home/tramites.component';
import { SacyrInputComponent } from './shared/sacyr-input/sacyr-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MensajeDmComponent } from './home/Components/mensaje-dm.component';
import { MensajeDmService } from './services/mensaje-dm.service';


@NgModule({
  declarations: [
    AppComponent,
    ContactComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    HeaderComponent,
    HeaderLoginComponent,
    MenumobileComponent,
    MenudesktopComponent,
    DatosCorrespondenciaComponent,
    ConsumofacturaComponent,
    LecturaContadorComponent,
    FaqComponent,
    ResetPasswordComponent,
    ValCodA2PComponent,
    ValTlfA2PComponent,
    DomiciliacionFacturaComponent,
    UsuarioComponent,
    SimuladorConsumoComponent,
    GraficoComponent,
    ChangePasswordComponent,
    ContactpublicComponent,
    CalendarioComponent,
    UploadFileComponent,
    MainComponent,
    FaqValorizaComponent,
    FaqGuadalaguaComponent,
    FaqSoriaComponent,
    AlertBoxComponent,
    DocumentosComponent,
    EncuestasComponent,
    ReclamacionesComponent,
    TramitesComponent,
    SacyrInputComponent,
    MensajeDmComponent
  ],
  imports: [
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(AppRoutes, { useHash: true }),
    ChartsModule,
    CalendarModule,
    DataTableModule,
    SidebarModule,
    Ng4LoadingSpinnerModule.forRoot(),
    NgxPageScrollModule,
    CookieLawModule,
    ReactiveFormsModule
  ],
  exports: [
    SacyrInputComponent,
  ],
  providers: [SessionService, AuthorizationGuard, GoogleAnalyticsService, MensajeDmService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(protected _googleAnalyticsService: GoogleAnalyticsService) { } // We inject the service here to keep it alive whole time

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/app.module.ts